<template>
	<div class="events">
		<navComponent/>
		<div id="wrapper" class="container-fluid">
			<div class="" style="display: flex;">
				<div class="mr-1" style="min-width: 410px;">
					<div style="display: flex">
						<div class="m-0" style="width: 110px">
							<div class="card">
								<div
												class="card-body text-center"
												style="padding: 10px !important;"
								>
									<a
													href="javascript:void(0)"
													class="text-center"
													@click="showSessions()"
									>
										<i class="fa fa-user mb-0" style="font-size: 25px;"></i
										><br/>
										<span style="font-size: 12px;">Sessions</span>
									</a>
									<br/><br/>
									<a
													href="javascript:void(0)"
													class="text-center"
													@click="showAudience()"
									>
										<i class="fa fa-users mb-0" style="font-size: 25px;"></i
										><br/>
										<span style="font-size: 12px;">Audience</span>
									</a>
									<br/><br/>
									<a
													href="javascript:void(0)"
													class="text-center"
													@click="showChats()"
									>
										<i class="fa fa-comments mb-0" style="font-size: 25px;"></i>
										<br/>
										<span style="font-size: 12px;">Chats</span> </a
									><br/><br/>
									<a
													href="javascript:void(0)"
													class="text-center"
													@click="hideMyVideo()"
									>
										<i class="fas fa-eye-slash" style="font-size: 25px;"></i>
										<br/>
										<span style="font-size: 12px;">Hide</span>
									</a>
									<br/><br/>
								</div>
							</div>
						</div>
						<div class="m-0" style="min-width: 300px;">
							<div class="card" v-if="sessions_bool">
								<div class="card-header"><b>Sessions</b></div>
								<div
												class="card-body"
												style="height: calc(100vh - 80px);overflow-y: scroll;"
								>
									<div
													style="border: 1px solid #fff; border-radius: 5px; padding: 8px;margin-top: 10px; cursor: pointer"
													v-for="(e, i) in event['sessions']"
													:key="i"
									>
										<h6>
											<b>{{ e.session_name }}</b>
											<i
															class="fas fa-angle-right"
															style="float: right; margin-top: 40px; font-size: 20px;"
											></i>
										</h6>
										<p class="mb-0">
											Speakers:
											<span v-for="(s, si) in event.speakers" :key="si">{{
                        s
                      }}</span>
										</p>
										<br/>
										<!--<span class="badge badge-warning mt-2">Ongoing</span>-->
										<span class="badge badge-danger mt-2">Completed</span>
										<!--<span class="badge badge-success mt-2">Not Started</span>-->
									</div>
								</div>
							</div>
							<div class="card" v-if="audience_bool">
								<div class="card-header" style="background: #101010"><b>Audience</b></div>
								<div class="card-body"></div>
							</div>
							<div class="card" v-if="chats_bool">
								<div class="card-header"><b>Chats</b></div>
								<div class="card-body"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="" style="width: -webkit-fill-available;">
					<div class="card">
						<div class="card-body">
							<span>Welcome xyz,</span>
							<h4 class="mb-0"><b>Networking Break is On. Grab a Seat.</b></h4>
							<p>Sit on a virtual table below and video chat with fellow participants.</p>
							<div class="container">
								<div
												class="row justify-content-center text-center"
												style="height: 740px; border-radius: 5px;overflow-y: auto">
									<div class="col-12 col-sm-6 col-md-4">
										<div class="table-item">
											<button class="btn btn-sm btn-primary float-right m-1">Grab a seat</button>
											<div class="round-table">
											</div>
											<div class="chair chair-up"></div>
											<div class="chair chair-down"></div>
											<div class="chair chair-right"></div>
											<div class="chair chair-left"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card-body wrapper meeting">
							<div class="ag-header">
								<div class="ag-header-lead">
									<span>{{ event.title }}</span>
									<span @click="handleJoin" class="join">Join</span>
									<span @click="handleLeave" class="leave">Leave</span>
									<span @click="handleScreenShare" class="screenShare"
									>Share Screen</span
									>
									<span @click="handleAudio" class="mute"
									>Mute Audio</span
									>
									<span @click="handleVideo" class="mute"
									>Diable Audio</span
									>
								</div>
								<div class="ag-header-msg">
									Room:&nbsp;<span id="room-name">{{ option.channel }}</span>
								</div>
							</div>
							<div class="ag-main">
								<div class="ag-container">
									<div id="ag-canvas">
										<!-- <div class="ag-btn-group">
											<span
												@click="handleExit"
												class="ag-btn exitBtn"
												:class="{ disabled: !readyState }"
												title="Exit"
											>
												<i class="fa fa-user"></i>
											</span>
											<span
												v-if="attendeeMode === 'video'"
												@click="handleCamera"
												class="ag-btn videoControlBtn"
												title="Enable/Disable Video"
											>
												<i class="fas fa-video"></i>
												<i class="fas fa-video-slash"></i>
											</span>
											<span
												v-if="attendeeMode !== 'audience'"
												@click="handleMic"
												class="ag-btn audioControlBtn"
												title="Enable/Disable Audio"
											>
												<i class="fas fa-microphone"></i>
												<i class="fas fa-microphone-slash"></i>
											</span>
											<span
												@click="switchDisplay"
												class="ag-btn displayModeBtn"
												:class="{ disabled: rtc.remoteStreams.length > 4 }"
												title="Switch Display Mode"
											>
												<i class="fas fa-th-large"></i>
											</span>
											<span
												class="ag-btn disableRemoteBtn"
												:class="{
													disabled:
														rtc.remoteStreams.length > 4 ||
														displayMode !== 'pip',
												}"
												@click="hideRemote"
												title="Hide Remote Stream"
											>
												<i class="fas fa-share-square"></i>
											</span>
											<span
												class="ag-btn disableRemoteBtn"
												@click="screenShare(this.rtc.params.uid)"
												title="Hide Remote Stream"
											>
												<i class="fas fa-share-square"></i>
											</span>
										</div> -->
										<div
														id="video"
														style="position: static !important; height: 100px; width: 100px; margin-left: 15px;"
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import AgoraRTC from "agora-rtc-sdk";
  import navComponent from "@/components/nav.vue";
  // import { merge } from "lodash";
  // import UAParser from "ua-parser-js";
  import $ from "jquery";
  import UAParser from 'ua-parser-js'

  const parser = new UAParser()
  const userAgentInfo = parser.getResult();

  // const parser = new UAParser();

  // const userAgentInfo = parser.getResult();
  // const tile_canvas = {
  //   "1": ["span 12/span 24"],
  //   "2": ["span 12/span 12/13/25", "span 12/span 12/13/13"],
  //   "3": ["span 6/span 12", "span 6/span 12", "span 6/span 12/7/19"],
  //   "4": [
  //     "span 6/span 12",
  //     "span 6/span 12",
  //     "span 6/span 12",
  //     "span 6/span 12/7/13",
  //   ],
  //   "5": [
  //     "span 3/span 4/13/9",
  //     "span 3/span 4/13/13",
  //     "span 3/span 4/13/17",
  //     "span 3/span 4/13/21",
  //     "span 9/span 16/10/21",
  //   ],
  //   "6": [
  //     "span 3/span 4/13/7",
  //     "span 3/span 4/13/11",
  //     "span 3/span 4/13/15",
  //     "span 3/span 4/13/19",
  //     "span 3/span 4/13/23",
  //     "span 9/span 16/10/21",
  //   ],
  //   "7": [
  //     "span 3/span 4/13/5",
  //     "span 3/span 4/13/9",
  //     "span 3/span 4/13/13",
  //     "span 3/span 4/13/17",
  //     "span 3/span 4/13/21",
  //     "span 3/span 4/13/25",
  //     "span 9/span 16/10/21",
  //   ],
  // };

  export default {
    name: "home",
    data() {
      return {
        user: {},
        event: {
          host_id: "",
          speakers: [],
        },
        displayMode: "pip",
        rtc: {
          client: null,
          joined: false,
          published: false,
          localStream: null,
          remoteStreams: [],
          params: {},
        },
        videoProfile: "480p_4",
        channel: "test",
        transcode: "interop",
        attendeeMode: "video",
        option: {
          appID: "b9f0c5f870c5466cb5befd8a408eeca6",
          channel: "",
          uid: null,
          token: "",
        },
        sessions_bool: true,
        audience_bool: false,
        chats_bool: false,
        readyState: false,
        audioFlag: true,
        videoFlag: true,
        videocall_bool: false,
      };
    },
    components: {
      navComponent,
    },
    methods: {
      showSessions: function () {
        this.sessions_bool = false
        this.audience_bool = true
        this.chats_bool = false
      },
      showAudience: function () {
        this.sessions_bool = false
        this.audience_bool = true
        this.chats_bool = false
      },
      showChats: function () {
        this.sessions_bool = false
        this.audience_bool = false
        this.chats_bool = true
      },
      hideMyVideo: function () {
        this.videocall_bool = true
      },
      handleAudio() {
        const $ = this;
        let newRtc = $.rtc;
        if ($.audioFlag) {
          newRtc.localStream.muteAudio();
          $.audioFlag = false;
        } else {
          newRtc.localStream.unmuteAudio();
          $.audioFlag = true;
        }
      },
      handleVideo() {
        const $ = this;
        let newRtc = $.rtc;
        if ($.videoFlag) {
          newRtc.localStream.muteVideo();
          $.videoFlag = false;
        } else {
          newRtc.localStream.unmuteVideo();
          $.videoFlag = true;
        }
      },
      handleJoin() {
        const $ = this;
        // Create a client
        let newRtc = $.rtc;
        let newOption = $.option;
        const role = "audience";
        this.rtc.client = AgoraRTC.createClient({mode: "live", codec: "h264"});

        // Initialize the client
        newRtc.client.init(
          newOption.appID,
          function () {
            console.log("init success");
            // Join a channel
            newRtc.client.setClientRole(role);
            newRtc.client.join(
              newOption.token,
              newOption.channel,
              newOption.uid ? newOption.uid : null,
              function (uid) {
                console.log(
                  "join channel: " + newOption.channel + " success, uid: " + uid
                );
                // newRtc.client.setClientRole("host");
                newRtc.params.uid = uid;
                // Create a local stream
                newRtc.localStream = AgoraRTC.createStream({
                  streamID: newRtc.params.uid,
                  audio: true,
                  video: true,
                  screen: false,
                });

                // Initialize the local stream
                newRtc.localStream.init(
                  function () {
                    console.log("init local stream success");
                    // play stream with html element id "local_stream"
                    // if ($.attendeeMode !== "audience") {
                    //
                    // }
                    newRtc.localStream.play("ag-canvas");
                    // Publish the local stream
                    newRtc.client.publish(newRtc.localStream, function (err) {
                      console.log("publish failed");
                      console.error(err);
                    });
                    // newRtc.localStream.play("ag-canvas");
                    // // Publish the local stream
                    // newRtc.client.publish(newRtc.localStream, function(err) {
                    //   console.log("publish failed");
                    //   console.error(err);
                    // });
                  },
                  function (err) {
                    console.error("init local stream failed ", err);
                  }
                );
                // Set the video profile with the setVideoEncoderConfiguration method.
                newRtc.stream.setVideoEncoderConfiguration({
                  // The video resolution.
                  resolution: {
                    width: 640,
                    height: 480,
                  },
                  // The video frame rate (fps). We recommend setting it as 15. Do not set it to a value greater than 30.
                  frameRate: {
                    min: 15,
                    max: 30,
                  },
                  // The video bitrate (Kbps). Refer to the video profile table below to set this parameter.
                  bitrate: {
                    min: 1000,
                    max: 5000,
                  },
                });
                newRtc.stream.setBeautyEffectOptions(true, {
                  lighteningContrastLevel: 1,
                  lighteningLevel: 0.7,
                  smoothnessLevel: 0.5,
                  rednessLevel: 0.9,
                });

                // Set the video profile with the setVideoProfile` method.
                // Sets the video profile as 480p_3, which means a resolution of 480 x 480, a frame rate of 15, and a bitrate of 400.
                newRtc.localStream.setVideoProfile("480p_3");
              },
              function (err) {
                console.error("client join failed", err);
              }
            );
          },
          (err) => {
            console.error(err);
          }
        );
        // Set the client role
        // Subscribe to a remote stream when the stream is added.
        newRtc.client.on("stream-added", function (evt) {
          var remoteStream = evt.stream;
          var id = remoteStream.getId();
          if (id !== newRtc.params.uid) {
            newRtc.client.subscribe(remoteStream, function (err) {
              console.log("stream subscribe failed", err);
            });
          }
          console.log("  remote-uid: ", id);
        });
        // Play the remote stream after subscribing to it.
        // Set the client role
        newRtc.client.on("stream-subscribed", function (evt) {
          var remoteStream = evt.stream;
          var id = remoteStream.getId();
          // Add a view for the remote stream.
          $.addView(id, true);
          // Play the remote stream.
          remoteStream.play("remote_video_" + id);
          console.log("stream-subscribed remote-uid: ", id);
        });
        // Set the client role
        // newRtc.client.setClientRole("audience");
        // When the remote stream is removed
        newRtc.client.on("stream-removed", function (evt) {
          var remoteStream = evt.stream;
          var id = remoteStream.getId();
          // Stop playing the remote stream.
          remoteStream.stop("remote_video_" + id);
          // Remove the view of the remote stream.
          $.removeView(id);
          console.log("stream-removed remote-uid: ", id);
        });
      },
      handleLeave() {
        // Leave the channel
        let newRtc = this.rtc;
        newRtc.client.leave(
          function () {
            // Stop playing the local stream
            newRtc.localStream.stop();
            // Close the local stream
            newRtc.localStream.close();
            // Stop playing the remote streams and remove the views
            while (newRtc.remoteStreams.length > 0) {
              var stream = newRtc.remoteStreams.shift();
              var id = stream.getId();
              stream.stop();
              this.removeView(id);
            }
            console.log("client leaves channel success");
          },
          function (err) {
            console.log("channel leave failed");
            console.error(err);
          }
        );
      },
      addView(id, show) {
        if (!$("#" + id)[0]) {
          $("<div/>", {
            id: "remote_video_panel_" + id,
            class: "video-view",
          }).appendTo("#video");
          $("<div/>", {
            id: "remote_video_" + id,
            class: "video-placeholder",
          }).appendTo("#remote_video_panel_" + id);
          $("<div/>", {
            id: "remote_video_info_" + id,
            class: "video-profile " + (show ? "" : "hide"),
          }).appendTo("#remote_video_panel_" + id);
          $("<div/>", {
            id: "video_autoplay_" + id,
            class: "autoplay-fallback hide",
          }).appendTo("#remote_video_panel_" + id);
        }
      },
      removeView(id) {
        if ($("#remote_video_panel_" + id)[0]) {
          $("#remote_video_panel_").remove();
        }
      },
      isFirefox() {
        return userAgentInfo.browser.name === "Firefox";
      },
      isCompatibleChrome() {
        if (userAgentInfo.browser.name === 'Chrome') {
          const major = userAgentInfo.browser.major
          if (major >= 72) return true
        }
        return false
      },
      handleScreenShare() {
        const $ = this;
        let newRtc = this.rtc;
        // Check if the browser supports screen sharing without an extension
        // const ua = userAgentInfo,
        //   tem =
        //     userAgentInfo.match(
        //       /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        //     ) || [];
        // Number.tem = userAgentInfo.match(/(Chrome(?=\/))\/?(\d+)/i);
        // Create the stream for screensharing
        //TODO: Fill in your App ID.
        let appID = $.option.appID;
        let channel = $.option.channel;
        let channelKey = null;
		// AgoraRTC.Logger.enableLogUpload();
		// AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.OFF);
		

        let localStreams = [];

        let screenClient = AgoraRTC.createClient({
          mode: "rtc",
          codec: "vp8",
        });
        screenClient.init(appID, function () {
          screenClient.join(
            $.option.token,
            channelKey,
            channel,
            null,
            function (uid) {
              // Save the uid of the local stream.
              localStreams.push(uid);
              // Create the stream for screen sharing.
              const streamSpec = {
                streamID: uid,
                audio: false,
                video: false,
                screen: true,
              };
              // Set relevant attributes according to the browser.
              // Note that you need to implement isFirefox and isCompatibleChrome.
              if ($.isFirefox()) {
                streamSpec.mediaSource = "window";
              } else if (!$.isCompatibleChrome()) {
                streamSpec.extensionId = "minllpmhdgpndnkomcoccfekfegnlikg";
              }
              newRtc.screenStream = AgoraRTC.createStream(streamSpec);
              // Initialize the stream.
              newRtc.screenStream.init(
                function () {
                  // Play the stream.
                  newRtc.screenStream.play("Screen");
                  // Publish the stream.
                  screenClient.publish(newRtc.screenStream);

                  // Listen to the 'stream-added' event.
                  screenClient.on("stream-added", function (evt) {
                    var stream = evt.stream;
                    var uid = stream.getId();

                    // Check if the stream is a local uid.
                    if (!localStreams.includes(uid)) {
                      console.log("subscribe stream:" + uid);
                      // Subscribe to the stream.
                      screenClient.subscribe(stream);
                    }
                  });
                },
                function (err) {
                  console.log(err);
                }
              );
            },
            function (err) {
              console.log(err);
            }
          );
        });

        let videoClient = AgoraRTC.createClient({
          mode: "rtc",
          codec: "vp8",
        });
        videoClient.init(appID, function () {
          videoClient.join(
            $.option.token,
            channelKey,
            channel,
            null,
            function (uid) {
              // Save the uid of the local stream.
              localStreams.push(uid);

              // Create the video stream.
              newRtc.videoStream = AgoraRTC.createStream({
                streamID: uid,
                audio: true,
                video: true,
                screen: false,
              });
              // Initialize the stream.
              newRtc.videoStream.init(
                function () {
                  // Play the stream.
                  newRtc.videoStream.play("Video");
                  // Publish the stream.
                  videoClient.publish(newRtc.videoStream);
                  // Listen to the 'stream-added' event.
                  videoClient.on("stream-added", function (evt) {
                    var stream = evt.stream;
                    var uid = stream.getId();
                    // Check if the stream is a local uid.
                    if (!localStreams.includes(uid)) {
                      console.log("subscribe stream:" + uid);
                      // Subscribe to the stream.
                      screenClient.subscribe(stream);
                    }
                  });
                },
                function (err) {
                  console.log(err);
                }
              );
            },
            function (err) {
              console.log(err);
            }
          );
        });

      },
      getEventDetailFunction: function () {
        let data = {
          event_id: this.$route.params.id,
        };
        this.$store.dispatch("getEventDetailOutside", data).then((resp) => {
          if (resp.data.status === "success") {
            this.event = resp.data.data;
            this.option.channel = this.event.title;
            this.channel = this.event.title;
            this.getTokenFunction();
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
			  position: "top",
			  queue: true
            });
          }
        });
      },
      getTokenFunction: function () {
        let data = {
          event_id: this.$route.params.id,
        };
        this.$store.dispatch("getToken", data).then((resp) => {
          if (resp.data.status === "success") {
            this.option.token = resp.data.data.token;
            // this.option.uid = resp.data.data.uid;
            this.attendeeMode = resp.data.data.role;
            // if (this.user.id === this.event.host.id) {
            //   this.setClient()
            // }
            // this.setClient();
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
			  position: "top",
			  queue: true
            });
          }
        });
      },
    },
    created() {
      this.getEventDetailFunction();
      if (localStorage.getItem("user_info")) {
        this.user = JSON.parse(localStorage.getItem("user_info"));
      } else {
        this.$router.push("/home");
      }
    },
  };
</script>

<style scoped lang="scss">
	#video {
		position: static !important;
	}

	.join {
		width: 100px;
		background: yellow;
		color: black;
		padding: 10px;
		margin: auto;
		margin: 5px;
		border-radius: 50px;
		cursor: pointer;
	}

	.mute {
		width: 100px;
		background: yellow;
		color: black;
		padding: 10px;
		margin: auto;
		margin: 5px;
		border-radius: 50px;
		cursor: pointer;
	}

	.leave {
		width: 100px;
		background: yellow;
		color: black;
		padding: 10px;
		margin: auto;
		border-radius: 50px;
		cursor: pointer;
	}

	.screenShare {
		width: 100px;
		background: yellow;
		color: black;
		padding: 10px;
		margin: auto;
		border-radius: 50px;
		cursor: pointer;
	}

	video {
		position: static !important;
	}

	.round-table {
		width: 80.9px;
		height: 67.6px;
		background-color: rgb(86, 86, 86);
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 3;
		border-radius: 14px;
	}

	.table-item {
		width: 230px;
		height: 250px;
		background-color: rgba(51, 51, 51, 0.8);
		display: inline-block;
		position: relative;
		border-radius: 16px;
		margin: 5px;
	}

	.chair {
		width: 38.6px;
		height: 38.9px;
		background-color: rgb(173, 172, 172);
		z-index: 2;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.chair-up {
		top: calc(50% - 45px);
	}

	.chair-down {
		top: calc(50% + 40px);
	}

	.chair-right {
		left: calc(50% + 40px);
	}

	.chair-left {
		left: calc(50% - 40px);
	}

	.chair.chair-up::after {
		top: -4px;
	}

	.chair.chair-left::after {
		left: -4px;
		height: 38.89px;
		width: 7.9px;
	}

	.chair.chair-right::after {
		right: -4px;
		height: 38.89px;
		width: 7.9px;
	}

	.chair.chair-down::after {
		bottom: -4px;
	}

	.chair::after {
		display: block;
		content: "";
		width: 38.89px;
		height: 7.9px;
		background-color: rgb(140, 140, 140);
		position: absolute;
	}

	.meeting.wrapper {
		background: #1b1b1b;
		height: 100%;
	}

	.meeting .ag-header {
		padding: 20px 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.ag-header-lead {
		font-size: 16px;
		line-height: 35px;
	}

	.meeting .ag-footer {
		padding: 0 30px;
		display: flex;
		align-items: center;
	}

	.meeting .ag-main {
		position: relative;
	}

	.meeting .ag-footer :first-child {
		margin-right: 80px;
	}

	.header-logo {
		width: 60px;
		height: 35px;
		margin-right: 12px;
	}

	.ag-container {
		width: calc(100% - 60px);
		height: 100%;
		margin: 0 auto;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 12px;
	}

	#ag-canvas {
		height: 790px;
		// display: grid;
		grid-gap: 10px;
		align-items: center;
		justify-items: center;
		grid-template-rows: repeat(12, auto);
		grid-template-columns: repeat(24, auto);
	}

	.ag-item :first-child {
		border-radius: 6px;
		height: 100%;
		width: 100%;
	}

	.ag-item {
		border-radius: 6px;
		border: 2px #1b1b1b solid;
		background: url("../assets/bg-1.jpg") center no-repeat;
		height: 100%;
		width: 100%;
	}

	#ag-resize-container {
		background-image: none !important;
		background-color: black;
		display: flex;
		justify-content: center;
		height: center;
	}

	#ag-resize-container .ag-item {
		border: none !important;
		height: 100%;
		width: 100%;
	}

	/* button group */
	.ag-btn-group {
		border-radius: 12px;
		height: 70px;
		width: calc(100% - 60px);
		margin: 0 auto;
		position: absolute;
		bottom: 0;
		background: transparent;
		z-index: 11;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.ag-btn-group:hover,
	.ag-btn-group.active {
		background: #383838;
	}

	.ag-btn {
		z-index: 12;
		/*opacity: 0;*/
		color: #feb22a;
		/* width: 35px;
				height: 35px; */
		cursor: pointer;
		font-size: 25px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		background: #232323b3;
		padding: 20px 20px;
		border: 1px solid #feb22a;
		border-radius: 12px;
		margin: 10px 10px 30px 10px;
	}

	.ag-btn:hover {
		color: #1b1b1b;
	}

	.ag-btn.disabled,
	.ag-btn.disabled:hover {
		color: #637c8e;
		cursor: not-allowed;
	}

	.ag-btn-group:hover .ag-btn,
	.ag-btn-group.active .ag-btn {
		/*opacity: 1;*/
	}

	.ag-btn.off.videoControlBtn .fa-video {
		display: none;
	}

	.ag-btn.videoControlBtn .fa-video-slash {
		display: none;
	}

	.ag-btn.videoControlBtn .fa-video {
		display: inline-block;
	}

	.ag-btn.off.videoControlBtn .fa-video-slash {
		display: inline-block;
	}

	.ag-btn.off.audioControlBtn .fa-microphone {
		display: none;
	}

	.ag-btn.audioControlBtn .fa-microphone-slash {
		display: none;
	}

	.ag-btn.audioControlBtn .fa-microphone {
		display: inline-block;
	}

	.ag-btn.off.audioControlBtn .fa-microphone-slash {
		display: inline-block;
	}

	.ag-header,
	.ag-footer {
		/* flex-basis: 70px; */
		width: 100%;
		opacity: 0.8;
		height: 70px;
		color: #fff;
	}

	.ag-main {
		width: 100%;
		height: calc(100% - 140px);
		display: flex;
		flex-flow: column;
		justify-content: center;
		align-items: center;
	}

	.ag-rounded {
		border-radius: 19px !important;
	}

	.ag-href {
		color: #fff;
		cursor: pointer;
	}

	.ag-href:hover {
		color: #fff;
	}

	#ag-canvas {
		div {
			video {
				height: 300px !important;
			}
		}
	}

	@media (max-width: 1000px) {
		#ag-canvas {
			height: 690px;
		}
	}
</style>
